<script setup lang="ts">
import { ref } from "vue";
import { mapState } from "../../context/context";
import Pop from "./Pop.vue";
import Calendar from "../form/Calendar.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Pop, Calendar },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    title?: string; // 标题
    initDay?: string; // 当前日期
    startDay?: string; // 可选范围：开始日期
    endDay?: string; // 可选范围：结束日期
    excludeDays?: string[]; // 排除日期范围，要求已按日历排序
    selectedDays?: string[]; // 已选择日期范围，要求已按日历排序
  }>(),
  {
    title: "",
    excludeDays: () => [],
    selectedDays: () => []
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
  (event: "cancel"): void;
  (event: "confirm", date: Date): void;
}>();

const mappedState = mapState(["color.foregroundPattern"]);

const el = ref();

function open() {
  el.value?.open();
}
function close() {
  el.value?.close();
}

function confirm(date) {
  emits("confirm", date);
  close();
}

function cancel() {
  emits("cancel");
  close();
}

defineExpose({ open, close });
</script>

<template>
  <Pop
    ref="el"
    directionFrom="bottom"
    :closeWhenClickOverlay="false"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div
      class="pop-calendar"
      :style="{
        backgroundColor: `${mappedState['color.foregroundPattern'].value}`
      }"
    >
      <Calendar
        :title="props.title"
        :initDay="props.initDay"
        :startDay="props.startDay"
        :endDay="props.endDay"
        :excludeDays="props.excludeDays"
        :selectedDays="props.selectedDays"
        @confirm="confirm"
        @cancel="cancel"
      ></Calendar>
    </div>
  </Pop>
</template>

<style scoped>
.pop-calendar {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}
</style>
